import { Controller } from 'stimulus'
import jump from 'jump.js'

export default class extends Controller {
  moreInfo(e: Event) {
    e.preventDefault()
    jump('main')
  }
}
